import React from 'react';
import { Select } from '@mui/material';

/**
 * Select outlined con notch de label (requerido en MUI v5 junto a InputLabel).
 */
const OutlinedSelect = React.forwardRef(({ label, labelId, children, ...props }, ref) => (
  <Select
    ref={ref}
    labelId={labelId}
    label={label}
    {...props}
  >
    {children}
  </Select>
));

OutlinedSelect.displayName = 'OutlinedSelect';

export default OutlinedSelect;
